import {
	OnInit,
	Component,
	Renderer
} from '@angular/core';
import {
	SetFocusDirective
} from '../directives/set-focus.directive';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import {
	Location,
	LocationStrategy,
	PathLocationStrategy
} from '@angular/common';
import {
	Router,
	NavigationEnd,
	ActivatedRoute
} from '@angular/router';
@Component({
	selector: 'app-root',
	templateUrl: '../views/app.component.html',
	styleUrls: ['../styles/app.component.css'],
	providers: [
		Location,
		{
			provide: LocationStrategy,
			useClass: PathLocationStrategy
		}
	],
	animations: [
		trigger('collapse', [
			state('open', style({
				opacity: '1',
				display: 'block',
				transform: 'translate3d(0, 0, 0)'
			})),
			state('closed',   style({
				opacity: '0',
				display: 'none',
				transform: 'translate3d(0, -100%, 0)'
			})),
			transition('closed => open', animate('200ms ease-in')),
			transition('open => closed', animate('100ms ease-out'))
		])
	]
})

export class AppComponent {
	public isCollapsed:string = "closed";
	location: Location;
	route: Router;
	renderer: Renderer;
	DEBUG = false;
	hideHeader: boolean = true;
	hideLogo = true;
	fabControl = '';
	bodyControl= '';
	title = 'Garth Rogers CPA & Tax Preperation';
	private layoutView(event:any){
		var nav = document.getElementById("navbar").classList;
		var fab = document.getElementById("fabdiv").classList;
		var header = document.getElementById('header');
		var logo = document.getElementById('logo');

		if(window.innerWidth < 768){
			this.hideHeader = true;
			this.hideLogo = false;
			this.bodyControl = 'navbar-fixed-body';
			nav.add("navbar-fixed-top");
			fab.add("fixed-fab");
			// document.getElementById('fabdiv').classList.add('fixed-fab');
		} else {
			this.hideHeader = false;
			this.hideLogo = true;
			fab.remove("app-fab-mobile");
		}
		if(!this.hideHeader){
			if (window.pageYOffset > header.offsetHeight+8){
				nav.add("navbar-fixed-top");
				this.bodyControl = 'navbar-fixed-body';
				// if(this.hideHeader)
					fab.add("fixed-fab");
			}else{
				nav.remove("navbar-fixed-top");
				this.bodyControl = '';
				// if(this.hideHeader)
					fab.remove("fixed-fab");
			}
		}
	}
	constructor(location: Location, router: Router, renderer: Renderer){
		this.location = location;
		this.route = router;
		this.renderer = renderer;
		this.renderer.listenGlobal('window', 'load', (evt) => { this.layoutView(evt) });
		this.renderer.listenGlobal('window', 'scroll', (evt) => { this.layoutView(evt) });
		this.renderer.listenGlobal('window', 'resize', (evt) => { this.layoutView(evt) });
		this.route.events.subscribe((evt)=>{
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			var header = document.getElementById('header');
			if(window.pageYOffset > header.offsetHeight+10){			
				window.scrollTo({
					left:0,
					top:header.offsetHeight+10,
					behavior: 'smooth'
				});
			}
		});
	}
	OnInit() {
		this.layoutView(null);
	}
	/*******************************************************************
	** @name isActive
	**
	** @brief  Determines if a link active.
	**
	** @param  path        The current site path
	**
	** @return Active, otherwise return empty string.
	**/
	public isActive(path:string){
		if(this.DEBUG){
			console.log('Active Path: ', path);
			console.log('Selected Path: ', this.route.url);
		}
		return (this.route.url.indexOf(path) !== -1) ? 'kactive' : '' ;
	}
	public collapsed(event:any):void{
		if(this.DEBUG){
			console.log(event);
		}
	}

	public expanded(event:any):void{
		if(this.DEBUG){
			console.log(event);
		}
	}
	isIn = false;   // store state

	toggleState() { // click handler
		let bool = this.isIn;
		this.isIn = !this.isIn;
		var nav = document.getElementById("navbar").classList;
		if(this.isIn){
			nav.add('app-navbar-fixed');
		} else {
			nav.remove('app-navbar-fixed');
		}
	}
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/app.component.ts